// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import vuetify from '@/plugins/vuetify'
import store from '@/store'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueAnalytics, {
    id: 'UA-164554439-1',
    router
  })
}

Vue.use(VueI18n)
const messages = require('@/lang/messages.json')
const language = localStorage.locale || (window.navigator.languages && window.navigator.languages[0]) ||
            window.navigator.language ||
            window.navigator.userLanguage ||
            window.navigator.browserLanguage
const locale = (language.indexOf('ja') > -1) ? 'ja' : 'en'
const i18n = new VueI18n({
  locale: locale,
  messages
})

/* eslint-disable no-new */
new Vue({
  vuetify,
  store,
  i18n,
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js